
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/DeliveryBrand",
      function () {
        return require("private-next-pages/article/DeliveryBrand.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/DeliveryBrand"])
      });
    }
  